/* KEIKA: FONTPLUS(有料フォント)を明朝体の箇所に適用する
 * Figma の「FOT-TsukuAOldMin Pr6N L」(筑紫Aオールド明朝 L) を FONTPLUS の配信名で指定し、
 * 後から描画される要素にも反映されるよう FONTPLUS.reload を呼ぶ。 */
(function () {
  if (window.__keikaFontplus) return;
  window.__keikaFontplus = true;
  var MIN = '"FOT-筑紫Aオールド明朝 Pr6N L", "FOT-TsukuAOldMin Pr6N", "Shippori Mincho", serif';
  var css = '[style*="TsukuAOldMin"], [style*="Shippori Mincho"], .keika-mincho { font-family: ' + MIN + ' !important; }';
  var st = document.createElement("style");
  st.id = "keika-fontplus-map";
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var timer = null, count = 0;
  function reload() {
    if (!window.FONTPLUS || typeof FONTPLUS.reload !== "function") return;
    try { FONTPLUS.reload(false); } catch (e) {}
  }
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; reload(); }, 400);
  }
  function start() {
    reload();
    [800, 2000, 4000].forEach(function (t) { setTimeout(reload, t); });
    // React で後から描画・差し替えされる文字にも配信する(一定回数まで)
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (++count > 200) { mo.disconnect(); return; }
        schedule();
      });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
